import * as MuiIcons from "@mui/icons-material";
import * as Mui from "@mui/material";
import { useFormik } from "formik";
import { useContext, useEffect, useState } from "react";
import { ContextOperation } from "../../context/OperationContext";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import useSnackbar from "../../hooks/useSnackbar";
import MonySymbolsComponets from "../common/MonySymbolsComponents";
import { nameof } from "../common/ObjectUtils";
import FormInput from "../common/FormInput";
import { useForm } from "react-hook-form";

import { FirstFuelingType } from "./FirstFuelingType";
import { vehicleActions } from "../../service/vehicle.actions";
interface Props {
  open: boolean;
 // driver:FirstFuelingType.EditVehicle;
  onClose: () => void;
  tireType:any;
  vehicleId:number;
  updateDatasourceDamage: any;
//   onReset:()=>void;
//   formikValues:DamageTypes.FilterDamage;
}


const EditVehicle = (props: Props) => {
  const snackbar = useSnackbar();
  const { setLoading } = useContext(ContextOperation);
  const t = useOperationTranslation();
  const {tenant} = useContext(ContextOperation);
  const vehicleAction = vehicleActions();
  const re = /^[0-9\b]+$/;
  const maintenanceReg = /^(?!0{2,})(?:\d{1,13}(?:\.\d{1,2})?|\.\d{1,2}|\d+\.)$/;
  const keyLess =[
    {value:true,
        label:t("internOptionSelectName.yes")
    },{
        value:false,
        label:t("internOptionSelectName.no")
    }
  ]

  const isDisabled = () => {
    return  (JSON.stringify(form.getValues()) == '{}' || Object.values(form?.getValues()).every((x) => x == undefined || x == "" || x.toString().trim() == "")); 

};
  
function emptyStringToNullOrNumber(value: any) {
  return value === "" ? "" : + value;
}

   const onSubmit = () => {
    let editVehicleData ={
        connected: form.getValues().connected,
        currentTireType:form.getValues().currentTireType,
        imeiSecondary: form.getValues().imeiSecondary === undefined ? "" : form.getValues().imeiSecondary,
        keyless: form.getValues().keyless,
        kmMaintenance: form.getValues().kmMaintenance === "" ? 0 : form.getValues().kmMaintenance,
        maintenancePeriod: form.getValues().maintenancePeriod === "" ? 0 : form.getValues().maintenancePeriod,
      
    }
    setLoading(true);
    vehicleAction.updateVehicle(props.vehicleId,tenant,editVehicleData).then(
      () => {
        onClose();
        setLoading(false);
        props.updateDatasourceDamage();
        snackbar.show("success", t("vehicle.editActionSuccessMessage"));
      },
      (error: any) => {
        onClose();
        setLoading(false);
        // if (error.response.status == 409) {
          snackbar.show("error",error.response.data.error);
        
        // }
      },
      
    );
   };



  const form = useForm<FirstFuelingType.EditVehicle>({
    defaultValues: {},
    
  });
  useEffect(() => {
      if (typeof props.vehicleId !== "object") {
          vehicleAction.getEditableVehicle(tenant, props.vehicleId).then((vehicle: FirstFuelingType.EditVehicle) => {
              form.setValue("imeiSecondary", vehicle.imeiSecondary ?? "");
              form.setValue("currentTireType", vehicle.currentTireType);
              form.setValue("connected", vehicle.connected);
              form.setValue("keyless", vehicle.keyless);
              form.setValue("kmMaintenance", vehicle.kmMaintenance ?? "");
              form.setValue("maintenancePeriod", vehicle.maintenancePeriod ?? "");
          });
      }
  }, [props.open]);

  const onClose = () => {
    props.onClose();
  };

  return (
    <Mui.Dialog open={props.open} onClose={onClose} fullWidth maxWidth="lg">
      <Mui.DialogTitle>
        <Mui.Grid container alignItems="center">
          <Mui.Grid item xs="auto">
            <Mui.Typography variant="h6">
              {t("vehicle.editVehicle.title")}
            </Mui.Typography>
          </Mui.Grid>
          <Mui.Grid item xs="auto" marginLeft="auto">
            <Mui.IconButton onClick={onClose}>
              <MuiIcons.Close />
            </Mui.IconButton>
          </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogTitle>
      <Mui.DialogContent>
      <form id ="damagePrice-list"
        onSubmit={form.handleSubmit(onSubmit)}>
           <Mui.Grid container spacing="16px" p ={2}>
           <Mui.Grid item md={3} xs={12}>
              <FormInput
                        type="text"
                        label={t("vehicle.tabPanel1.imeiSecondary")}
                        name ={nameof<FirstFuelingType.EditVehicle>("imeiSecondary")}
                        fullWidth
                        formInstance={form}
                        value={`${form.watch("imeiSecondary")}` || ""}
                        onChange={(newStatusValue) => {
                          //form.setValue("imeiSecondary", newStatusValue);
                          
                          if (
                            newStatusValue === "" ||
                            re.test(newStatusValue)
                          ) {
                            form.setValue(
                              "imeiSecondary",newStatusValue
                            );
                          }
                          
                        }}
                      />
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
          <FormInput
            type ="select"
            label={t("vehicle.tabPanel1.currentTireType")}
            name ={nameof<FirstFuelingType.EditVehicle>("currentTireType")}
            options={props.tireType}
            value={form.watch("currentTireType")}
            disableClearable ={true}
            onChange={(newStatusValue) => {
              form.setValue("currentTireType", newStatusValue);
            }}
            fullWidth/>
            </Mui.Grid>

            <Mui.Grid item md={3} xs={12}>
            <FormInput
             type ="select"
             label={t("vehicle.tabPanel1.keyless")}
             name ={nameof<FirstFuelingType.EditVehicle>("keyless")}
             options={keyLess}
             disableClearable ={true}
             value ={form.watch("keyless")}
             onChange={(newStatusValue) => {
                form.setValue("keyless", newStatusValue);
              }}
            fullWidth/>
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
          <FormInput
            type ="select"
             label={t("vehicle.tabPanel1.connected")}
            name ={nameof<FirstFuelingType.EditVehicle>("connected")}
            options={keyLess}
            disableClearable ={true}
            value ={form.watch("connected")}
            onChange={(newStatusValue) => {
               form.setValue("connected", newStatusValue);
             }}
            fullWidth/>
            </Mui.Grid>
            </Mui.Grid>
            <Mui.Grid container spacing="16px" p ={2}>
            <Mui.Grid item md={3} xs={12}>
            <FormInput
            type ="text"
             label={t("vehicle.tabPanel1.kmMaintenance")}
            name ={nameof<FirstFuelingType.EditVehicle>("kmMaintenance")}
            value={`${form.watch("kmMaintenance")}` || ""}
            onChange={(newStatusValue) => {
              if (
                 newStatusValue === "" ||
                 re.test(newStatusValue)
              ) {
                form.setValue(
                  "kmMaintenance",emptyStringToNullOrNumber(newStatusValue)
                );
              }
            }}
            fullWidth/>
            </Mui.Grid>
            <Mui.Grid item md={3} xs={12}>
          <FormInput
            type ="text"
            label={t("vehicle.tabPanel1.maintenancePeriod")}
            name ={nameof<FirstFuelingType.EditVehicle>("maintenancePeriod")}
            formInstance={form}
            value={`${form.watch("maintenancePeriod")}`|| ""}
            onChange={(newStatusValue) => {
              if ( newStatusValue === "" ||
              re.test(newStatusValue)
              ) {
                form.setValue(
                  "maintenancePeriod",emptyStringToNullOrNumber(newStatusValue)
                );
              }
            }}
            fullWidth/>
            </Mui.Grid>
           
           
            </Mui.Grid>
           

            </form>
      </Mui.DialogContent>
      <Mui.DialogActions>
        <Mui.Grid container justifyContent="end" spacing="16px">
          <Mui.Grid item xs="auto">
            <Mui.Button variant="outlined"  size="medium"    onClick={onClose}>
            <Mui.Typography variant="h6" color ="accent.main"> {t(
                "vehicleEquipmentAssociation.dialogs.editAcriss.actions.cancel"
              )}
            </Mui.Typography>
            </Mui.Button>
          </Mui.Grid>
          <Mui.Grid item xs="auto">
             <Mui.Button  onClick ={()=> onSubmit()} size="medium" disabled ={isDisabled()}>
             <Mui.Typography variant="h6" color ="accent.contrastText"> {t("vehicleEquipmentAssociation.dialogs.editAcriss.actions.save")}</Mui.Typography>
            </Mui.Button>
           </Mui.Grid>
        </Mui.Grid>
      </Mui.DialogActions> 
      
    </Mui.Dialog>
  );
};

export default EditVehicle;
